<template>
  <v-dialog
    v-model="visible"
    max-width="350"
  >
    <v-card>
      <v-card-title class="headline">{{ this.$t('delete_account_dialog_title') }}</v-card-title>
      <v-card-text>{{ this.$t('delete_account_dialog_body') }}</v-card-text>
      <v-card-actions>
        <v-btn flat @click="close">
          {{ this.$t('cancel') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn flat @click="confirm">
          {{ this.$t('confirm') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script> 
  export default {
    name: 'delete-account-dialog',
    data () {
      return {
      }
    },
    props: {
      visible: {
        type: Boolean, 
        default: false
      },
    },
    methods: {
      close() {
        if (!this.visible)
          return
        this.$emit('update:visible', false)
      },
      confirm() {
        // TODO: show loader?
        this.$store.dispatch('deleteAccount').then(() => {
          //this.$router.replace({name:'Login'})
          this.close()
        })
      } 
    }
  }
</script>
